define([
    "underscore",
    "backbone",
    "backbone.form"
], function(_, Backbone) {
    return Backbone.Form.extend({
        url: "/rest_support/validate_customer_service_form",

        validation: {
            full_name:{
                required: true
            },
            email:{
                required: true,
                pattern: 'email'
            },
            message:{
                required: true
            },
            department:{
                required: true,
                oneOf: ["help", "partners", "account"]
            }
        }
    });
});



//////////////////
// WEBPACK FOOTER
// ./assets/common/main/js/forms/support/customer_service_form.js
// module id = 50
// module chunks = 0